export const LogoFull = () => (
  <svg height="34" viewBox="0 0 175 46" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="eLgF" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#4DD8E8" />
        <stop offset="50%" stopColor="#6B40E0" />
        <stop offset="100%" stopColor="#3A0FBB" />
      </linearGradient>
    </defs>

    {/* Ring 1 — top */}
    <ellipse cx="22" cy="11" rx="16" ry="6.5"
      fill="none" stroke="url(#eLgF)" strokeWidth="4.2" strokeLinecap="round"
      strokeDasharray="52 20" strokeDashoffset="0" />
    {/* Ring 1 back half (dim) */}
    <ellipse cx="22" cy="11" rx="16" ry="6.5"
      fill="none" stroke="url(#eLgF)" strokeWidth="4.2" strokeLinecap="round"
      strokeDasharray="20 52" strokeDashoffset="-52" opacity="0.35" />

    {/* Ring 2 — middle */}
    <ellipse cx="22" cy="23" rx="16" ry="6.5"
      fill="none" stroke="url(#eLgF)" strokeWidth="4.2" strokeLinecap="round"
      strokeDasharray="52 20" strokeDashoffset="0" />
    <ellipse cx="22" cy="23" rx="16" ry="6.5"
      fill="none" stroke="url(#eLgF)" strokeWidth="4.2" strokeLinecap="round"
      strokeDasharray="20 52" strokeDashoffset="-52" opacity="0.35" />

    {/* Ring 3 — bottom */}
    <ellipse cx="22" cy="35" rx="16" ry="6.5"
      fill="none" stroke="url(#eLgF)" strokeWidth="4.2" strokeLinecap="round"
      strokeDasharray="52 20" strokeDashoffset="0" />
    <ellipse cx="22" cy="35" rx="16" ry="6.5"
      fill="none" stroke="url(#eLgF)" strokeWidth="4.2" strokeLinecap="round"
      strokeDasharray="20 52" strokeDashoffset="-52" opacity="0.35" />

    {/* Text */}
    <text x="47" y="32"
      fontFamily="Inter, 'Segoe UI', Arial, sans-serif"
      fontSize="24" fontWeight="600" fill="white" letterSpacing="-0.3">
      everon
    </text>
  </svg>
);
